module.exports = __webpack_public_path__ + "images/links/125x125-B.png";